






import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';


export default Vue.extend({
  name: 'index',
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover' }
    ]
  },
  components: {
  },
  data() {
    return {
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  computed: {
    ...mapState(['windowWidth'])
  },
  mounted() {
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapMutations(['setWindowWidth']),
    handleResize() {
      this.setWindowWidth(window.innerWidth)
    }
  }
});
